'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * This is a subset of enum `Placements`
 */ exports.ComboboxPlacements = void 0;
(function(ComboboxPlacements) {
    ComboboxPlacements["BottomStart"] = 'bottom-start';
    ComboboxPlacements["TopStart"] = 'top-start';
})(exports.ComboboxPlacements || (exports.ComboboxPlacements = {}));
//# sourceMappingURL=combobox.js.map
